import React from 'react'
import { Routes, Route } from 'react-router'

import { LoadingRoute, LazyLoadingMainComponent } from '../components/LazyComponent'

import { useSession } from '../providers/SessionProvider'

const UserProfile = React.lazy(() => import('../containers/settings/UserProfile'))

const EmailNotifications = React.lazy(() => import('../containers/settings/EmailNotifications'))

const PersonalAccessTokens = React.lazy(() => import('../containers/settings/PersonalAccessTokens'))

const CreatePersonalAccessToken = React.lazy(() => import('../containers/settings/CreatePersonalAccessToken'))

const EditPersonalAccessToken = React.lazy(() => import('../containers/settings/EditPersonalAccessToken'))

const AuthorisedApplications = React.lazy(() => import('../containers/settings/AuthorisedApplications'))

const NotAuthorised = React.lazy(() => import('../containers/NotAuthorised'))

const User = () => {
  const { currentUser, loading } = useSession()

  if (loading) return <LoadingRoute />

  return (
    <Routes>
      <Route
        path="settings/profile"
        element={
          <LazyLoadingMainComponent>{currentUser ? <UserProfile /> : <NotAuthorised />}</LazyLoadingMainComponent>
        }
      />
      <Route
        path="settings/email-notifications"
        element={
          <LazyLoadingMainComponent>
            {currentUser ? <EmailNotifications /> : <NotAuthorised />}
          </LazyLoadingMainComponent>
        }
      />
      <Route
        exact
        path="settings/applications"
        element={
          <LazyLoadingMainComponent>
            {currentUser ? <AuthorisedApplications /> : <NotAuthorised />}
          </LazyLoadingMainComponent>
        }
      />
      <Route
        exact
        path="settings/tokens"
        element={
          <LazyLoadingMainComponent>
            {currentUser ? <PersonalAccessTokens /> : <NotAuthorised />}
          </LazyLoadingMainComponent>
        }
      />
      <Route
        exact
        path="settings/tokens/new"
        element={
          <LazyLoadingMainComponent>
            {currentUser ? <CreatePersonalAccessToken /> : <NotAuthorised />}
          </LazyLoadingMainComponent>
        }
      />
      <Route
        exact
        path="settings/tokens/:uuid/edit"
        element={
          <LazyLoadingMainComponent>
            {currentUser ? <EditPersonalAccessToken /> : <NotAuthorised />}
          </LazyLoadingMainComponent>
        }
      />
    </Routes>
  )
}

export default User
